import React, { useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { CascadePickerView  } from 'antd-mobile';
import Modal from '../../../../components/Modal';
import useBasicFormData from "../../store/useBasicFormData";
import { paddingLeftZero } from '../../../../utils/date';
import { TAB_ID_SET } from '../../config/constants';
import './index.scss';
interface CascadePickerTypes {
  label: string,
  value: string,
  children: {
    label: string,
    value: string,
  }[],
}

export default function TimePicker(props) {
  const { showModal, onHide, children, onConfirm, className = '', defaultValue, ...restProps } = props;
  const { basicFormData } = useBasicFormData();
  const [isShowModal, setShowModal] = useState(showModal);
  const [pickupDate, setPickupDate] = useState('');
  const [cascadeOptions, setCascadeOptions] = useState<CascadePickerTypes[]>([]);
  const [value, setValue] = useState<(number | string | null)[]>(defaultValue)
  
  useEffect(() => {
    setShowModal(showModal);
  }, [showModal]);

  // 生成时间列表
  const generateHourMinuteList = useCallback((from, to) => {
    const list: CascadePickerTypes[] = [];
    for(let i = from; i <= to; i++) {
      list.push({
        label: `${i}`,
        value: `${i}`,
        children: generateMinuteList(0, i < to ? 50 : 0), // 最大值为等于到店时间
      })
    }
    return list;
  }, [])

  // 设置取车日期
  useEffect(() => {
    if (!basicFormData.storeTimeStepData) return;
    const {
      reserveType: reserveTabIndex,
      arriveStoreTimeData,
      arriveStoreTimeByDateTab,
    } = basicFormData.storeTimeStepData;

    // 根据选中 tab 获取时间内容
    const reserveTimeInfo = reserveTabIndex === TAB_ID_SET.STORE_TAB ? arriveStoreTimeData : arriveStoreTimeByDateTab;

    if (reserveTimeInfo) {
      const { timestamp, startTime = '' } = reserveTimeInfo;
      const dd = new Date(timestamp);
      setPickupDate(`${dd.getFullYear()}年${dd.getMonth() + 1}月${dd.getDate()}日`)

      // 时分限制在选中到店时间之前
      const [hour, min] = startTime.split(':');
      const hourList = generateHourMinuteList(8, Number(hour))
      // console.log('hourList ....>>>>>>>>>>>>>>>>>>>>>>>>>', hourList);
      setCascadeOptions(hourList);
    }
  }, [basicFormData.storeTimeStepData, generateHourMinuteList]);

  const generateMinuteList = (from, to) => {
    const list: {
      label: string,
      value: string,
    }[] = [];
    for(let i = from; i <= to; ) {
      list.push({
        label: `${paddingLeftZero(i)}`,
        value: `${paddingLeftZero(i)}`,
      })
      i += 10;
    }
    return list;
  }

  const onConfirmHandler = () => {
    onConfirm(value);
    hideModal();
  }
  
  const hideModal = () => {
    setShowModal(false);
  }

  return ReactDOM.createPortal(
    <Modal
      className={`${className} picker-modal-wrapper`}
      isOpened={isShowModal}
      onHide={onHide}
      position='bottom'
      title='选择时间'
      {
        ...restProps
      }
    >
      <div className="pickup-date-text">
        取车日期 {pickupDate}
      </div>
      <div className="picker-view-wrapper">
        <CascadePickerView
          defaultValue={defaultValue}
          value={value}
          style={{ '--height': '4.320rem', '--item-height': '0.75rem', '--item-font-size': '0.36rem' }}
          options={cascadeOptions}
          onChange={(val, extend) => {
            setValue(val)
            console.log('on CascadePickerView Change', val, extend.items)
          }}
        />
      </div>
      <div className="action-field">
        <div className="confirm-btn" onClick={onConfirmHandler}>确定</div>
      </div>
    </Modal>,
    document.body,
  );
}
